import api from "./api"

export const fetchWallets = async ({ queryKey }) => {
  const [, { page, limit, search, orderBy, fetch }] = queryKey;
  let url = `/wallets?page=${page}&limit=${limit}`;
  
  if (search) {
    url += `&search=${search}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (fetch) {
    url += `&fetch=${fetch}`;
  }

  const response = await api.get(url);
  return response.data;
}

export const fetchWallet = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  const response = await api.get(`/wallets/${id}`);
  return response.data;
}

export const fetchTransactionHistory = async ({ queryKey }) => {
  const [, { id, page, limit, search, walletType }] = queryKey;
  let url = `/wallets/${id}/ledger?page=${page}&limit=${limit}`

  if (search) {
    url += `&search=${search}`;
  }

  if (walletType) {
    url += `&walletType=${walletType}`;
  }

  const response = await api.get(url);
  return response.data;
}

export const fetchWalletMetrics = async({ queryKey }) => {
  const [, { fetch }] = queryKey;
  let url = `/wallets/metrics?fetch=${fetch}`;
  const response = await api.get(url);
  return response.data;
}

export const fetchWalletLedgers = async ({ queryKey }) => {
  const [, { page, limit, search, status, fetch, orderBy, searchBy, searchByExactMatch }] = queryKey;
  let url = `/wallets/ledgers?page=${page}&limit=${limit}`;

  if (search) {
    url += `&search=${search}`;
  }
  if (status) {
    url += `&status=${status}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (fetch) {
    url += `&fetch=${fetch}`;
  }
  if (searchBy && Array.isArray(searchBy)) {
    const params = searchBy.map((field) => `searchBy=${field}`).join('&');
    url += `&${params}`;
  }
  if (searchByExactMatch) {
    url += `&searchByExactMatch=${searchByExactMatch}`;
  }

  const response = await api.get(url);
  return response.data;
}

export const fetchWalletLedger = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  const response = await api.get(`/wallets/ledger/${id}`);
  return response.data;
}

export const fetchLedgerMetrics = async ({ queryKey }) => {
  const [, { event }] = queryKey;
  const response = await api.get(`/wallets/ledgers/metrics?event=${event}`);
  return response.data;
}

export const exportWallet = async (data) => {
  const response = await api.post(`/export/wallet`, data);
  return response.data;
}

export const exportWalletHistory = async (event, data) => {
  const response = await api.post(`/export/walletLedger?event=${event}`, data);
  return response.data;
}

export const walletReconciliation = async (data) => {
  const response = await api.post(`/reconciliation/wallet`, data)
  return response.data;
}

export const fetchWalletState = async ({ queryKey }) => {
  const [, { page, limit, search, orderBy, fetch, searchBy, searchByExactMatch }] = queryKey;
  let url = `/wallets/state?page=${page}&limit=${limit}`

  if (search) {
    url += `&search=${search}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (fetch) {
    url += `&fetch=${fetch}`;
  }
  if (searchBy && Array.isArray(searchBy)) {
    const params = searchBy.map((field) => `searchBy=${field}`).join('&');
    url += `&${params}`;
  }
  if (searchByExactMatch) {
    url += `&searchByExactMatch=${searchByExactMatch}`;
  }

  const response = await api.get(url);
  return response.data;
}

export const lockWallet = async (data) => {
  const response = await api.post(`/wallets/lock`, data);
  return response.data;
}

export const setUserTransferLimit = async (data) => {
  const response = await api.put(`/wallets/daily-transfer-limit`, data);
  return response.data;
}

export const setBulkUserTransferLimit = async (data) => {
  const response = await api.put(`/wallets/bulk-daily-transfer-limit`, data);
  return response.data;
}

export const fetchLockedWallets = async () => {
  const response = await api.get(`/wallets/lock/wallets`);
  return response.data
}

export const generateAccountStatement = async (data) => {
  const response = await api.post(`/wallets/export-statement`, data);
  return response.data;
}